// extracted by mini-css-extract-plugin
export default {"button":"Vk-z","reviewSort":"Wk-z"};